export default {
  methods: {
    // Convert system language code to ISO-639-1
    // https://cloud.google.com/translate/docs/languages
    formatLanguageCodeForTranslation: (lang) => {
      let convertedLang = '';
      switch (lang) {
        case 'cn':
          convertedLang = 'zh';
          break;
        case 'cz':
          convertedLang = 'cs';
          break;
        case 'gr':
          convertedLang = 'el';
          break;
        case 'se':
          convertedLang = 'sv';
          break;
        case 'ua':
          convertedLang = 'uk';
          break;
        default:
          convertedLang = lang;
          break;
      }
      return convertedLang;
    },
  },
};
